import { render, staticRenderFns } from "./SuratJalanDeliveryDetailInput.vue?vue&type=template&id=545d5b54&scoped=true&"
import script from "./SuratJalanDeliveryDetailInput.vue?vue&type=script&lang=js&"
export * from "./SuratJalanDeliveryDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./SuratJalanDeliveryDetailInput.vue?vue&type=style&index=0&id=545d5b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d5b54",
  null
  
)

export default component.exports